/* eslint-disable camelcase */
import React, { useMemo } from 'react';
import { useReactiveVar, useSuspenseQuery } from '@apollo/client';
import { selectedPeriodVar } from 'app/apollo/reaction';
import PREVIEW_CART_FOR_SET from 'app/graphql/network/previewCartForSet';

const setTypeCollection = [
    'tomorrow',
    'green',
    'our_set',
];


export const useDynamicSetPrice = (setType: string): any => {
    const period = useReactiveVar(selectedPeriodVar);

    const queryVars = {
        period,
        set_type: setType,
    };

    const isValidSetType = setTypeCollection.includes(setType);

    if (!isValidSetType) {
        return {
            priceOfSet: null,
            hasDishesInSet: true,
        };
    }

    const {
        data,
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useSuspenseQuery(PREVIEW_CART_FOR_SET, {
        variables: queryVars,
        context: {
            message: 'menu:init:BasketPreview',
        },
    });

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const sections_IDs = useMemo(
        () => {
            // @ts-expect-error
            const flatSection = data?.previewCartForSet?.sections?.reduce(
                (acc: any, section: any) => [...acc, ...section.items], [],
            ) || [];
            return flatSection.map((itm: any) => itm.dish_id);
        },
        // @ts-expect-error
        [data?.previewCartForSet?.sections],
    );

    // @ts-ignore
    const hasDishesInSet = Boolean(data?.previewCartForSet?.sections.length);

    // @ts-ignore
    const previewCartForSet = data?.previewCartForSet?.totals || {};
    const { total_price: totalPriceFromPreview } = previewCartForSet;
    return {
        priceOfSet: totalPriceFromPreview,
        hasDishesInSet,
        sections_IDs,
    };
};
